import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { EmptyStateView, Loader } from '@atlas/ui';

const getText = isFavorites =>
  isFavorites
    ? {
        description: 'empty_favorites_message_text',
        title: 'empty_favorites_message_title',
      }
    : {
        description: 'empty_games_message',
        title: 'no_games',
      };

export const EmptyState = ({ isFavorites, loading }) => {
  const text = useMemo(() => getText(isFavorites), [isFavorites]);

  if (loading) {
    return (
      <div className="empty-state absolute">
        <Loader />
      </div>
    );
  }

  return <EmptyStateView className="absolute" description={text.description} title={text.title} />;
};

EmptyState.propTypes = {
  isFavorites: PropTypes.bool,
  loading: PropTypes.bool,
};
